<div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-12">

          <p>The Security Intel Report is published monthly by the Orange Cyberdefense Security Research Centre. The report contains a summary of all the Threat Advisories that were released during that month along with statistical and trend analysis based on those advisories. The report also contains summaries of noteworthy items that did not warrant a full advisory along with some commentary on current events affecting the cyber security realm</p>
          <br/>

          <div class="row">
            <div class="col-3 text-center" *ngFor="let file of fileNames">

                  <div class="card boxshadow">
                      <div class="card-body m-h-7">
                          <div class="d-flex no-block text-center">
                              <div class="m-r-20 align-self-center"><fa-icon [icon]="['far', 'file']" size="lg" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon>
                              </div>
                              <div class="align-self-center max-width">
                                  {{convertFileName(file)}}
                                  <br/><br/>
                                  <button type="button" (click)="downloadFile(file)"  class="btn btn-primary">{{ 'pages.generic.downloadPDF' | translate}}</button>
                              </div>
                          </div>
                      </div>
                  </div>
            </div>
            </div>

        </div>
      </div>

  </div>
</div>